export default "__VITE_ASSET__B2GlWCwd__"